export default __webpack_public_path__ + "assets/certificates/Steel_Rope_Test_certificate.a7cd7d30.pdf";